<div class="modal-header">
  <div>
    <h4 class="modal-title">
      {{ "FranchisedOptions.assignTitle" | translate }}
    </h4>
    <h5 class="m-b-0 m-t-10">
      {{ "FranchisedOptions.assignDescription" | translate }}
    </h5>
  </div>
  <button type="button" class="btn-close" (click)="closeModal()"></button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="form-group">
      <label class="label"
        ><b>{{ "FranchisedOptions.assignLocations" | translate }}</b></label
      >
      <ng-select
        formControlName="location"
        [items]="resultAllLPCompanyNames"
        [multiple]="true"
        [closeOnSelect]="false"
        [placeholder]="
          'advertisingCampaign.create.placeholders.selectLocations' | translate
        "
        [ngClass]="{
          'is-invalid':
            !form.get('location')?.valid && form.get('location')?.touched
        }"
        [required]="true"
      >
        <ng-template ng-option-tmp let-item="item" let-index="index">
          <div class="form-check checkbox checkbox-primary mb-0 ml-10">
            <input
              class="form-check-input m-r-10"
              type="checkbox"
              [checked]="form.get('location')?.value?.includes(item)"
            />
            <label class="form-check-label label">{{ item }}</label>
          </div>
        </ng-template>
      </ng-select>
    </div>
    <div class="form-group" style="margin-top: 12px">
      <label class="label"
        ><b>{{ "FranchisedOptions.assignFranchises" | translate }}</b></label
      >
      <ng-select class="singleChose"
        formControlName="franchise"
        [items]="resultAllFranchisesCompanyNames"
        [multiple]="false"
        [closeOnSelect]="true"
        [placeholder]="
          'FranchisedOptions.assignFranchisePlaceholder' | translate
        "
        [required]="true"
      >
      </ng-select>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-primary" (click)="closeModal()">
    {{ "buttons.close" | translate }}
  </button>
  <button
    class="btn btn-primary"
    (click)="assignFranchised()"
    [disabled]="!form.valid"
  >
    {{ "buttons.confirm" | translate }}
  </button>
</div>
